import { useQuery } from "react-query";
import { fetcher } from "@weezevent/weezjs-core";
import { getSortingQueryString } from "../../../helpers/sorting";
import { handleSearchQuery } from "../../../utils/filters";
import { convertFiltersToValidTypes } from "utils/filterParamsMethods";
import {
	IdentificationType,
	IDENTIFICATION_TYPE_TO_PARAM
} from "../components/filter";

const specFilters = {
	fields: ["event_ids", "checkpoint_ids", "status"]
};

const getAttendees = (
	organizationId,
	{ search, searchType, sorting, filters = {}, limit = 50, offset = 0 } = {}
) => {
	const identificationTypeToSend =
		IDENTIFICATION_TYPE_TO_PARAM[searchType || IdentificationType.ALL];
	const queryParams = {
		limit,
		offset,
		...getSortingQueryString(sorting, {
			attendee: "last_name",
			rate_name: "rate__name",
			event_name: "rate__event__name",
			has_scans: "with_scans"
		}),
		...filters,
		[identificationTypeToSend]: search || undefined
	};

	return fetcher
		.get(`/organizations/${organizationId}/attendees`, {
			query: queryParams,
			endpoint: window.weezConfig.api.apiUrl
		})
		.then(response => {
			return response;
		});
};

const useAttendeeList = ({
	organization,
	search,
	searchType,
	sorting,
	filters,
	enabled,
	page = 0,
	pageSize = 50
}) => {
	const filters_as_arrays = convertFiltersToValidTypes(filters);

	const offset = page * pageSize;

	const query = useQuery(
		[
			"attendee-list",
			organization,
			search,
			searchType,
			sorting,
			filters_as_arrays,
			page,
			pageSize
		],
		async () => {
			const res = await getAttendees(organization.id(), {
				search: search || undefined,
				searchType: searchType || IdentificationType.ALL,
				sorting,
				filters: handleSearchQuery(specFilters, filters || {}),
				limit: pageSize,
				offset
			});

			return {
				data: res.response,
				totalCount: res.headers?.get("total-count") || 0,
				hasNextPage:
					offset + pageSize < (res.headers?.get("total-count") || 0)
			};
		},
		{
			enabled,
			staleTime: 1000
		}
	);

	return {
		...query,
		data: query.data?.data || [],
		totalCount: query.data?.totalCount || 0,
		hasNextPage: query.data?.hasNextPage || false,
		isFetchingNextPage: false,
		fetchNextPage: () => {}
	};
};

export default useAttendeeList;
